module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "y-input-wrapper",
    class: {
      'y-input-group': _vm.addonAfter !== undefined || _vm.addonBefore !== undefined
    }
  }, [(_vm.addonBefore) ? _c('span', {
    staticClass: "y-input-group-addon-before"
  }, [_vm._v(_vm._s(_vm.addonBefore))]) : _vm._e(), _vm._v(" "), (_vm.type == 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "y-input",
    class: _vm.size ? ("y-input-" + _vm.size) : '',
    attrs: {
      "type": "text",
      "readonly": _vm.read,
      "name": "",
      "autocomplete": "off",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm._s(_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }) : (_vm.type == 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "y-input",
    class: _vm.size ? ("y-input-" + _vm.size) : '',
    attrs: {
      "type": "password",
      "readonly": _vm.read,
      "name": "",
      "autocomplete": "off",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm._s(_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "y-input",
    domProps: {
      "value": _vm._s(_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.icon) ? _c('y-svg', {
    staticClass: "y-input-icon",
    attrs: {
      "type": _vm.iconType,
      "width": 16
    },
    nativeOn: {
      "click": function($event) {
        _vm.iconCbk($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addonAfter) ? _c('span', {
    staticClass: "y-input-group-addon-after"
  }, [_vm._v(_vm._s(_vm.addonAfter))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-3f38acd3!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/input/input.vue
// module id = 466
// module chunks = 27